import { CLASS_BG, CLASS_TEXT, CONV_LABELS, DeltaTag } from "./PerfSharedUI";

/**
 * Grid with 7 mini-cards for each inter-stage conversion. Each card is
 * coloured by its `classification` computed on the backend using the
 * KPI thresholds config.
 */
export default function ConversionsGrid({ data, onOpenThresholds }) {
  const conv = data?.conversions || {};
  const cls = data?.classifications || {};
  const deltas = data?.deltas?.conversions || {};
  return (
    <div className="bg-card border border-border rounded-2xl p-6 lg:p-8" data-testid="conversions-grid">
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">
            Taxas de conversão
          </div>
          <h3 className="font-display text-2xl">Onde estamos a perder oportunidades</h3>
        </div>
        {onOpenThresholds && (
          <button
            onClick={onOpenThresholds}
            className="text-xs text-foreground hover:underline font-semibold"
            data-testid="open-thresholds"
          >
            Configurar metas →
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {Object.entries(CONV_LABELS).map(([key, label]) => {
          const pct = conv[key] ?? 0;
          const c = cls[key] || "unknown";
          return (
            <div key={key} className={`rounded-xl border-2 p-4 ${CLASS_BG[c]}`} data-testid={`conv-${key}`}>
              <div className="text-[10px] uppercase tracking-[0.15em] text-muted-foreground font-semibold">
                {label}
              </div>
              <div className="flex items-baseline gap-2 mt-1">
                <span className={`font-display text-2xl ${CLASS_TEXT[c]}`}>{pct.toFixed(1)}%</span>
                <DeltaTag delta={deltas[key]} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
